import { useEffect, useState } from 'react';

const parts = (targetMs: number) => {
  const ms = Math.max(0, targetMs - Date.now());
  return {
    days: Math.floor(ms / 86_400_000),
    hrs: Math.floor((ms % 86_400_000) / 3_600_000),
    min: Math.floor((ms % 3_600_000) / 60_000),
  };
};

export function Countdown({ target }: { target: Date }) {
  const [t, setT] = useState(() => parts(target.getTime()));
  useEffect(() => {
    const id = setInterval(() => setT(parts(target.getTime())), 30_000);
    return () => clearInterval(id);
  }, [target]);

  const cell = (value: number, label: string) => (
    <div style={{ textAlign: 'center', minWidth: 56 }}>
      <div className="serif" style={{ fontSize: '2.4rem', fontWeight: 500, lineHeight: 1 }}>
        {value}
      </div>
      <div className="eyebrow" style={{ color: 'var(--text-dim)', marginTop: 6 }}>
        {label}
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: 24 }}>
      {cell(t.days, 'days')}
      {cell(t.hrs, 'hrs')}
      {cell(t.min, 'min')}
    </div>
  );
}
